"use strict";
const cssstyle = require("cssstyle");

class ElementCSSInlineStyle {
  _initElementCSSInlineStyle() {
    this._style = new cssstyle.CSSStyleDeclaration(newCssText => {
      if (!this._settingCssText) {
        this._settingCssText = true;
        this.setAttribute("style", newCssText);
        this._settingCssText = false;
      }
    });
  }
  get style() {
    return this._style;
  }
  set style(value) {
    this._style.cssText = value;
  }
}

module.exports = {
  implementation: ElementCSSInlineStyle
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_jsdom@13.2.0@jsdom/lib/jsdom/living/nodes/ElementCSSInlineStyle-impl.js
// module id = H3+w
// module chunks = 0